import { createUseStyles } from 'react-jss';
import type { Theme } from '@wds/styles';

type StyleClasses = 'pageContainer' | 'pageLogoLink';
type StyleProps = {};

const useStyles = createUseStyles<StyleClasses, StyleProps>(
  ({ palette, spacing, breakpoints }: Theme) => ({
    pageContainer: {
      backgroundColor: palette.background.main,
    },
    pageLogoLink: {
      position: 'fixed',
      top: spacing[5],
      left: spacing[5],
      margin: 0,
      width: 200,
      height: 30,

      [`@media (max-width: ${breakpoints.sm}px)`]: {
        position: 'relative',
        display: 'block',
        top: 0,
        left: 0,
        backgroundColor: palette.background.main,
      },
    },
  })
);

export default useStyles;
